/**
 * The one zone every rendered timestamp is formatted in.
 *
 * `Intl.DateTimeFormat` without an explicit `timeZone` uses whatever zone its
 * *runtime* is in. Next renders client components on the server first, so a cell
 * was formatted in the server's zone (UTC in a container) and then again in the
 * viewer's, which React reports as a hydration mismatch and which silently
 * changed the time — and, near midnight, the date — between the first paint and
 * the second (#965).
 *
 * Pinning one zone makes the two sides agree by construction rather than by
 * luck. It is also the right answer for the domain: a capture time is a fact
 * about when the sample was imaged in the lab, so it should not move because the
 * record was opened from somewhere else.
 *
 * Deliberately a constant and not an environment variable. A `NEXT_PUBLIC_` value
 * is inlined at build time *only when it is set during the build*; left unset, the
 * server would read the runtime value and the browser would fall back, which is
 * exactly the divergence this module exists to remove — and every other frontend
 * setting here is supplied at runtime, so that is how someone would naturally set
 * it. Making this per-deployment therefore means the app-mode route: a field in
 * the home backend's app config (`lib/app-config.ts`), a server getter in
 * `actions/app.ts` plus a provider, not a public env var.
 *
 * Kept in its own leaf module, like `parse-annotation-timestamp`, so server
 * components and `@/lib/utils` can both import it without a barrel cycle.
 */
export const DISPLAY_TIMEZONE = 'Europe/Zurich'
